module.exports = __webpack_public_path__ + "4650f2880ba9c9615dad6ec439faedbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/lyzarsky-vycvik-4.jpg
// module id = 1193
// module chunks = 0